import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ShieldScrollAnimation = ({ className = "" }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const rotateY = useTransform(scrollYProgress, [0, 1], [-15, 15]);
  const rotateX = useTransform(scrollYProgress, [0, 0.5, 1], [10, 0, -10]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.85, 1, 0.85]);
  const glowOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.2, 0.8, 0.2]);
  const sweepX = useTransform(scrollYProgress, [0, 1], [-100, 200]);

  return (
    <div ref={containerRef} className={`relative flex items-center justify-center ${className}`}>
      {/* Glow background */}
      <motion.div
        className="absolute inset-0 rounded-full blur-3xl"
        style={{
          opacity: glowOpacity,
          background: "radial-gradient(circle, rgba(59,130,246,0.3) 0%, transparent 70%)",
        }}
      />

      {/* Shield SVG */}
      <motion.div
        style={{
          rotateY,
          rotateX,
          scale,
          transformPerspective: 1200,
        }}
        className="relative"
      >
        <img src="/icono_trace_principal.png" alt="Shield" />

        {/* Sweep light effect */}
        <motion.div
          className="absolute inset-0 pointer-events-none overflow-hidden rounded-full"
          style={{ x: sweepX }}
        >
          <div className="w-16 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12" />
        </motion.div>
      </motion.div>

      {/* Orbiting particles */}
      {[0, 1, 2, 3].map((i) => (
        <motion.div
          key={i}
          className="absolute w-1.5 h-1.5 bg-blue-400/60 rounded-full"
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 8 + i * 2,
            repeat: Infinity,
            ease: "linear",
            delay: i * 0.5,
          }}
          style={{
            transformOrigin: `${80 + i * 20}px center`,
          }}
        />
      ))}
    </div>
  );
};
